import { connect } from 'react-redux';
import RegisterView from './register-view';
import { register } from '../../pages/people/people-reducer';

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        registerError: state.auth.signInErrorMessage,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        dispatchRegister: (user) => dispatch(register(user)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterView);
